/**
 * Ids are never typed (section 4): a new item's id comes from its name. Ids follow the backend's
 * rule (a letter or digit, then letters, digits and - . _ : /, at most 128). Pure.
 */

export function slugify(name: string): string {
  const slug = name
    .normalize("NFKD").replace(/[̀-ͯ]/g, "")
    .toLowerCase().replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
    .slice(0, 80).replace(/-+$/g, "");
  return slug || "item";
}

/** The slug, or the slug with -2, -3... when it is taken. */
export function uniqueId(name: string, taken: ReadonlySet<string>, prefix = ""): string {
  const base = `${prefix}${slugify(name)}`;
  if (!taken.has(base)) return base;
  for (let i = 2; ; i++) if (!taken.has(`${base}-${i}`)) return `${base}-${i}`;
}

export const ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:/-]{0,127}$/;
